<template lang="pug">
  main
    NavBarMonitor
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  Reportes
        .columns
          .column.is-12-desktop.is-12-tablet.has-text-centered
            .card
              .card-content
                .columns.is-vcentered
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    | Seleccione una fecha para los Reportes:
                    .field
                      .control
                        flat-pickr(
                          v-model='date'
                          :config="config"
                          class="input"
                        )
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    a.button.is-link(@click="generarReportes")
                      | Generar Reportes
        .columns.is-mobile(v-show="isShowReports")
          .column.is-4-desktop.is-4-tablet.is-12-mobile(v-show="isEB00_User || isAdmin")
            .card
              .card-content
                .columns
                  p.is-size-6
                    b Reportes EB00
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Generales
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkPM100_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPM100_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReportePatin }}
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Bombas
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkBombaA_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkBombaA_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteBombaA }}
                      .columns.card-row
                        a.button.is-danger(:href="linkBombaB_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkBombaB_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteBombaB }}
                        br
                      .columns.card-row
                        a.button.is-danger(:href="linkBombaC_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkBombaC_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteBombaC }}
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Válvulas
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        //- a.button.is-danger(:href="linkValvulas_I" target="_blank")
                        a.button.is-danger(@click="mostrarReporteValv('I')")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        //- a.button.is-dark.btn-down(:href="linkValvulas_D")
                        a.button.is-dark.btn-down(@click="mostrarReporteValv('D')")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteValvulas }}
                        br
                      .columns.card-row
                        a.button.is-danger(:href="linkValBis_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkValBis_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteValvBis }}
          .column.is-4-desktop.is-4-tablet.is-12-mobile(v-show="isTPA_User || isAdmin")
            .card
              .card-content
                .columns
                  p.is-size-6
                    b Reportes TPA
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Generales
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkCargasDiariasTPA_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkCargasDiariasTPA_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteCargasDiariasTPA }}
                      .columns.card-row
                        a.button.is-danger(:href="linkEsferasTPA_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkEsferasTPA_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteEsferasTPA }}
                      .columns.card-row
                        a.button.is-danger(:href="linkPM101_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPM101_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReportePM101 }}
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Llenaderas
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_301A_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_301A_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte301_A }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_301B_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_301B_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte301_B }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_301C_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_301C_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte301_C }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_301D_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_301D_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte301_D }}
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_302A_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_302A_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte302_A }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_302B_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_302B_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte302_B }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_302C_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_302C_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte302_C }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_302D_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_302D_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte302_D }}
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_303A_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_303A_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte303_A }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_303B_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_303B_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte303_B }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_303C_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_303C_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte303_C }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkPA_303D_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkPA_303D_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_Reporte303_D }}
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Esferas
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101A_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101A_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101A }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101B_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101B_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101B }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101C_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101C_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101C }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101D_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101D_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101D }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101E_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101E_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101E }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101F_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101F_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101F }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101G_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101G_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101G }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101H_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101H_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101H }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101I_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101I_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101I }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_101J_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_101J_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_101J }} 
          .column.is-4-desktop.is-4-tablet.is-12-mobile(v-show="isIRGE_User || isAdmin")
            .card
              .card-content
                .columns
                  p.is-size-6
                    b Reportes IRGE
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Generales
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkCargasDiariasIRGE_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkCargasDiariasIRGE_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteCargasDiariasIRGE }}
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkEsferasIRGE_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkEsferasIRGE_D" target="_blank")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteEsferasIRGE }}
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(href="" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(href="" target="_blank")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReportePatinIRGE }}
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Llenaderas
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkL_5_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_5_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_5_IRGE }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkL_6_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_6_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_6_IRGE }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkL_7_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_7_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_7_IRGE }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkL_8_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_8_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_8_IRGE }}
                      .columns.card-row
                        a.button.is-danger(:href="linkL_9_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_9_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_9_IRGE }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkL_10_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_10_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_10_IRGE }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkL_11_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_11_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_11_IRGE }}
                      
                      .columns.card-row
                        a.button.is-danger(:href="linkL_12_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_12_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_12_IRGE }}

                      .columns.card-row
                        a.button.is-danger(:href="linkL_13_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_13_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_13_IRGE }} 

                      .columns.card-row
                        a.button.is-danger(:href="linkL_14_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkL_14_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_ReporteL_14_IRGE }}
                bulma-accordion
                  bulma-accordion-item
                    p.title.is-4.has-text-weight-normal(slot='title')
                      | Esferas
                    i.material-icons(slot='icon') more_vert
                    .high(slot='content')
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_301A_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_301A_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_301A }}
                      .columns.card-row
                        a.button.is-danger(:href="linkTE_301B_I" target="_blank")
                          span.icon
                            i.fas.fa-print
                        | &nbsp
                        a.button.is-dark.btn-down(:href="linkTE_301B_D")
                          span.icon
                            i.fas.fa-file-download
                        | &nbsp {{ text_TE_301B }}  
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarMonitor from '@/components/estaciones_Componentes/NavBarMonitor.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import NotificacionConst from '@/components/shared/NotificacionConst.vue'

export default {
  name: 'Reportes',
  components: { Loader, NavBarMonitor, flatPickr, BulmaAccordion, BulmaAccordionItem, NotificacionConst },
  data () {
    return {
      isLoading: false,
      date: new Date(),
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only          
      },          
      isShowReports: false,
      isTPA_User: false,
      isEB00_User: false,
      isAdmin: false,
      isIRGE_User: false,
      isDucto_User: false,
      text_ReportePatin: '',
      text_ReporteBombaA: '',
      text_ReporteBombaB: '',
      text_ReporteBombaC: '',
      text_ReporteValvBis: '',
      text_ReporteValvulas: '',
      linkPM100_I: '',
      linkPM100_D: '',
      linkBombaA_I: '',
      linkBombaB_I: '',
      linkBombaC_I: '',
      linkBombaA_D: '',
      linkBombaB_D: '',
      linkBombaC_D: '',
      linkValBis_I: '',
      linkValBis_D: '',
      linkValvulas_I: '',
      linkValvulas_D: '',
      linkCargasDiariasTPA_I: '',
      linkCargasDiariasTPA_D: '',
      text_ReporteCargasDiariasTPA: '',
      linkEsferasTPA_I: '',
      linkEsferasTPA_D: '',
      text_ReporteEsferasTPA	: '',
      linkPM101_I: '',
      linkPM101_D: '',
      text_ReportePM101: '',
      linkPA_301A_I: '',
      linkPA_301A_D: '',
      linkPA_301B_I: '',
      linkPA_301B_D: '',
      linkPA_301C_I: '',
      linkPA_301C_D: '',
      linkPA_301D_I: '',
      linkPA_301D_D: '',
      linkPA_302A_I: '',
      linkPA_302A_D: '',
      linkPA_302B_I: '',
      linkPA_302B_D: '',
      linkPA_302C_I: '',
      linkPA_302C_D: '',
      linkPA_302D_I: '',
      linkPA_302D_D: '',
      linkPA_303A_I: '',
      linkPA_303A_D: '',
      linkPA_303B_I: '',
      linkPA_303B_D: '',
      linkPA_303C_I: '',
      linkPA_303C_D: '',
      linkPA_303D_I: '',
      linkPA_303D_D: '',
      text_Reporte301_A: '',
      text_Reporte301_B: '',
      text_Reporte301_C: '',
      text_Reporte301_D: '',
      text_Reporte302_A: '',
      text_Reporte302_B: '',
      text_Reporte302_C: '',
      text_Reporte302_D: '',
      text_Reporte303_A: '',
      text_Reporte303_B: '',
      text_Reporte303_C: '',
      text_Reporte303_D: '',
      linkTE_101A_I: '',
      linkTE_101B_I: '',
      linkTE_101C_I: '',
      linkTE_101D_I: '',
      linkTE_101E_I: '',
      linkTE_101F_I: '',
      linkTE_101G_I: '',
      linkTE_101H_I: '',
      linkTE_101I_I: '',
      linkTE_101J_I: '',
      linkTE_101A_D: '',
      linkTE_101B_D: '',
      linkTE_101C_D: '',
      linkTE_101D_D: '',
      linkTE_101E_D: '',
      linkTE_101F_D: '',
      linkTE_101G_D: '',
      linkTE_101H_D: '',
      linkTE_101I_D: '',
      linkTE_101J_D: '',
      text_TE_101A: '',
      text_TE_101B: '',
      text_TE_101C: '',
      text_TE_101D: '',
      text_TE_101E: '',
      text_TE_101F: '',
      text_TE_101G: '',
      text_TE_101H: '',
      text_TE_101I: '',
      text_TE_101J: '',
      text_ReportePatinIRGE: '',
      text_ReporteEsferasIRGE	: '',
      linkEsferasIRGE_I: '',
      linkEsferasIRGE_D: '',
      text_ReporteL_5_IRGE: '',
      text_ReporteL_6_IRGE: '',
      text_ReporteL_7_IRGE: '',
      text_ReporteL_8_IRGE: '',
      text_ReporteL_9_IRGE: '',
      text_ReporteL_10_IRGE: '',
      text_ReporteL_11_IRGE: '',
      text_ReporteL_12_IRGE: '',
      text_ReporteL_13_IRGE: '',
      text_ReporteL_14_IRGE: '',
      linkCargasDiariasIRGE_I: '',
      linkCargasDiariasIRGE_D: '',
      text_ReporteCargasDiariasIRGE: '',
      linkL_5_I: '',
      linkL_5_D: '',
      linkL_6_I: '',
      linkL_6_D: '',
      linkL_7_I: '',
      linkL_7_D: '',
      linkL_8_I: '',
      linkL_8_D: '',
      linkL_9_I: '',
      linkL_9_D: '',
      linkL_10_I: '',
      linkL_10_D: '',
      linkL_11_I: '',
      linkL_11_D: '',
      linkL_12_I: '',
      linkL_12_D: '',
      linkL_13_I: '',
      linkL_13_D: '',
      linkL_14_I: '',
      linkL_14_D: '',
      text_ReporteL_5: '',
      text_ReporteL_6: '',
      text_ReporteL_7: '',
      text_ReporteL_8: '',
      text_ReporteL_9: '',
      text_ReporteL_10: '',
      text_ReporteL_11: '',
      text_ReporteL_12: '',
      text_ReporteL_13: '',
      text_ReporteL_14: '',
      linkTE_301A_I: '',
      linkTE_301A_D: '',
      linkTE_301B_I: '',
      linkTE_301B_D: '',
      text_TE_301A: '',
      text_TE_301B: '',
    }
  },
  methods: {
    iniciarComponente () {
      this.obtenerUser()
    },
    obtenerUser() {

      switch (this.userLogin.categoria) {
        case 0:
          this.isAdmin = true  
          break
        case 1:
          this.isAdmin = false  
          break
        case 2:
          this.isAdmin = false
          switch (this.userLogin.ubicacion) {
            case 'TPA':
              this.isTPA_User = true
              this.isDucto_User = true
              break
            case 'IRGE':
              this.isIRGE_User = true
              this.isDucto_User = true
              break
            case 'EB00':
              this.isEB00_User = true
              this.isDucto_User = true
              break
            default:
              this.isDucto_User = true
              break
          }
          break
      
        default:
          switch (this.userLogin.ubicacion) {
            case 'TPA':
              this.isTPA_User = true
              this.isDucto_User = true
              break
            case 'IRGE':
              this.isIRGE_User = true
              this.isDucto_User = true
              break
            case 'EB00':
              this.isEB00_User = true
              this.isDucto_User = true
              break
            default:
              this.isDucto_User = true
              break
          }
          break
      }
    },
    generarReportes () {
      this.isLoading = true

      var currentUrl = window.location.hostname
      console.log(currentUrl)
      
      setTimeout(() => {
        this.isLoading = false
        this.text_ReportePatin = `${this.date}_PM100`
        this.text_ReporteBombaA = `${this.date}_BombaA`
        this.text_ReporteBombaB = `${this.date}_BombaB`
        this.text_ReporteBombaC = `${this.date}_BombaC`
        this.text_ReporteValBis = `${this.date}_ValBis`
        this.text_ReporteValvulas = `${this.date}_Valvulas`
        this.text_ReporteValvBis = `${this.date}_ValvulasBis`
        this.linkPM100_I = `https://${currentUrl}/servidores/EB00_pm_100_5_5I.php?fecha=${this.date}`
        this.linkPM100_D = `https://${currentUrl}/servidores/EB00_pm_100_5_5D.php?fecha=${this.date}`
        this.linkBombaA_I = `https://${currentUrl}/servidores/EB00_bombasI.php?fecha=${this.date}&bomba=A`
        this.linkBombaB_I = `https://${currentUrl}/servidores/EB00_bombasI.php?fecha=${this.date}&bomba=B`
        this.linkBombaC_I = `https://${currentUrl}/servidores/EB00_bombasI.php?fecha=${this.date}&bomba=C`
        this.linkBombaA_D = `https://${currentUrl}/servidores/EB00_bombasD.php?fecha=${this.date}&bomba=A`
        this.linkBombaB_D = `https://${currentUrl}/servidores/EB00_bombasD.php?fecha=${this.date}&bomba=B`
        this.linkBombaC_D = `https://${currentUrl}/servidores/EB00_bombasD.php?fecha=${this.date}&bomba=C`
        this.linkValBis_I = `https://${currentUrl}/servidores/Ducto_valvulasBisI.php?fecha=${this.date}`
        this.linkValBis_D = `https://${currentUrl}/servidores/Ducto_valvulasBisD.php?fecha=${this.date}`
        // this.linkValvulas_I= `https://${currentUrl}/servidores/valvulas.php?fecha=${this.date}`,
        // this.linkValvulas_D= `https://${currentUrl}/servidores/valvulas.php?fecha=${this.date}`,


        this.text_ReporteCargasDiariasTPA = `${this.date}_CargasDiarias`
        this.text_ReporteCargasDiariasIRGE = `${this.date}_CargasDiarias`
        this.text_ReporteEsferasTPA = `${this.date}_Inventario_EsferasTPA`
        this.text_ReporteEsferasIRGE = `${this.date}_Inventario_EsferasIRGE`
        this.text_ReportePM101 = `${this.date}_PatinPM-101`
        this.linkCargasDiariasTPA_I = `https://${currentUrl}/servidores/TPA_CargasDiariasI.php?fecha=${this.date}`
        this.linkCargasDiariasTPA_D = `https://${currentUrl}/servidores/TPA_CargasDiariasD.php?fecha=${this.date}`
        this.linkCargasDiariasIRGE_I = `https://${currentUrl}/servidores/reportes/IRGE_CargasDiariasI.php?fecha=${this.date}`
        this.linkCargasDiariasIRGE_D = `https://${currentUrl}/servidores/reportes/IRGE_CargasDiariasD.php?fecha=${this.date}`
        this.linkEsferasTPA_I = `https://${currentUrl}/servidores/TPA_EsferasInventarioI.php?fecha=${this.date}`
        this.linkEsferasTPA_D = `https://${currentUrl}/servidores/TPA_EsferasInventarioD.php?fecha=${this.date}`
        this.linkEsferasIRGE_I = `https://${currentUrl}/servidores/reportes/IRGE_InventarioEsferasI.php?fecha=${this.date}`
        this.linkEsferasIRGE_D = `https://${currentUrl}/servidores/reportes/IRGE_InventarioEsferasD.php?fecha=${this.date}`
        this.linkPM101_I = `https://${currentUrl}/servidores/TPA_patinPM-101I.php?fecha=${this.date}`
        this.linkPM101_D = `https://${currentUrl}/servidores/TPA_patinPM-101D.php?fecha=${this.date}`

        // Llenaderas

        this.text_Reporte301_A = `${this.date}_PA-301A`
        this.text_Reporte301_B = `${this.date}_PA-301B`
        this.text_Reporte301_C = `${this.date}_PA-301C`
        this.text_Reporte301_D = `${this.date}_PA-301D`
        this.text_Reporte302_A = `${this.date}_PA-302A`
        this.text_Reporte302_B = `${this.date}_PA-302B`
        this.text_Reporte302_C = `${this.date}_PA-302C`
        this.text_Reporte302_D = `${this.date}_PA-302D`
        this.text_Reporte303_A = `${this.date}_PA-303A`
        this.text_Reporte303_B = `${this.date}_PA-303B`
        this.text_Reporte303_C = `${this.date}_PA-303C`
        this.text_Reporte303_D = `${this.date}_PA-303D`
        
        this.text_ReporteL_5_IRGE = `${this.date}_L-5`
        this.text_ReporteL_6_IRGE = `${this.date}_L-6`
        this.text_ReporteL_7_IRGE = `${this.date}_L-7`
        this.text_ReporteL_8_IRGE = `${this.date}_L-8`
        this.text_ReporteL_9_IRGE = `${this.date}_L-9`
        this.text_ReporteL_10_IRGE = `${this.date}_L-10`
        this.text_ReporteL_11_IRGE = `${this.date}_L-11`
        this.text_ReporteL_12_IRGE = `${this.date}_L-12`
        this.text_ReporteL_13_IRGE = `${this.date}_L-13`
        this.text_ReporteL_14_IRGE = `${this.date}_L-14`

        this.linkPA_301A_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-301A`
        this.linkPA_301B_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-301B`
        this.linkPA_301C_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-301C`
        this.linkPA_301D_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-301D`
        this.linkPA_302A_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-302A`
        this.linkPA_302B_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-302B`
        this.linkPA_302C_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-302C`
        this.linkPA_302D_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-302D`
        this.linkPA_303A_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-303A`
        this.linkPA_303B_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-303B`
        this.linkPA_303C_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-303C`
        this.linkPA_303D_I = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaI.php?fecha=${this.date}&llenadera=PA-303D`

        this.linkL_5_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-5`
        this.linkL_6_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-6`
        this.linkL_7_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-7`
        this.linkL_8_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-8`
        this.linkL_9_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-9`
        this.linkL_10_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-10`
        this.linkL_11_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-11`
        this.linkL_12_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-12`
        this.linkL_13_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-13`
        this.linkL_14_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasI.php?fecha=${this.date}&llenadera=L-14`
        
        this.linkPA_301A_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-301A`
        this.linkPA_301B_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-301B`
        this.linkPA_301C_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-301C`
        this.linkPA_301D_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-301D`
        this.linkPA_302A_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-302A`
        this.linkPA_302B_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-302B`
        this.linkPA_302C_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-302C`
        this.linkPA_302D_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-302D`
        this.linkPA_303A_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-303A`
        this.linkPA_303B_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-303B`
        this.linkPA_303C_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-303C`
        this.linkPA_303D_D = `https://${currentUrl}/servidores/TPA_ReporteLlenaderaD.php?fecha=${this.date}&llenadera=PA-303D`

        this.linkL_5_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-5`
        this.linkL_6_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-6`
        this.linkL_7_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-7`
        this.linkL_8_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-8`
        this.linkL_9_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-9`
        this.linkL_10_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-10`
        this.linkL_11_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-11`
        this.linkL_12_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-12`
        this.linkL_13_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-13`
        this.linkL_14_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteLlenaderasD.php?fecha=${this.date}&llenadera=L-14`
        
        //Esferas
        this.text_TE_101A = `${this.date}_TE-101A`
        this.text_TE_101B = `${this.date}_TE-101B`
        this.text_TE_101C = `${this.date}_TE-101C`
        this.text_TE_101D = `${this.date}_TE-101D`
        this.text_TE_101E = `${this.date}_TE-101E`
        this.text_TE_101F = `${this.date}_TE-101F`
        this.text_TE_101G = `${this.date}_TE-101G`
        this.text_TE_101H = `${this.date}_TE-101H`
        this.text_TE_101I = `${this.date}_TE-101I`
        this.text_TE_101J = `${this.date}_TE-101J`

        this.text_TE_301A = `${this.date}_TE-301A`
        this.text_TE_301B = `${this.date}_TE-301B`

        this.linkTE_101A_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101A`
        this.linkTE_101B_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101B`
        this.linkTE_101C_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101C`
        this.linkTE_101D_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101D`
        this.linkTE_101E_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101E`
        this.linkTE_101F_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101F`
        this.linkTE_101G_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101G`
        this.linkTE_101H_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101H`
        this.linkTE_101I_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101I`
        this.linkTE_101J_I = `https://${currentUrl}/servidores/TPA_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-101J`

        this.linkTE_301A_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-301A`
        this.linkTE_301B_I = `https://${currentUrl}/servidores/reportes/IRGE_ReporteEsferasI.php?fecha=${this.date}&esfera=TE-301B`
        
        this.linkTE_101A_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101A`
        this.linkTE_101B_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101B`
        this.linkTE_101C_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101C`
        this.linkTE_101D_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101D`
        this.linkTE_101E_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101E`
        this.linkTE_101F_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101F`
        this.linkTE_101G_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101G`
        this.linkTE_101H_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101H`
        this.linkTE_101I_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101I`
        this.linkTE_101J_D = `https://${currentUrl}/servidores/TPA_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-101J`
        
        this.linkTE_301A_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-301A`
        this.linkTE_301B_D = `https://${currentUrl}/servidores/reportes/IRGE_ReporteEsferasD.php?fecha=${this.date}&esfera=TE-301B`
        

        // IRGE
        this.text_ReportePatinIRGE = `${this.date}_Patin_IRGE`
        //this.text_ReporteL_5_IRGE = `${this.date}_Llenadera5`
        //this.text_ReporteL_6_IRGE = `${this.date}_Llenadera6`
        //this.text_ReporteL_7_IRGE = `${this.date}_Llenadera7`
        //this.text_ReporteL_8_IRGE = `${this.date}_Llenadera8`
        //this.text_ReporteL_9_IRGE = `${this.date}_Llenadera9`
        //this.text_ReporteL_10_IRGE = `${this.date}_Llenadera10`
        //this.text_ReporteL_11_IRGE = `${this.date}_Llenadera11`
        //this.text_ReporteL_12_IRGE = `${this.date}_Llenadera12`
        //this.text_ReporteL_13_IRGE = `${this.date}_Llenadera13`
        //this.text_ReporteL_14_IRGE = `${this.date}_Llenadera14`
        
        this.isShowReports = true
      }, 1500);
    },
    mostrarReporteValv (accion) {
      var currentUrl = window.location.hostname
      console.log(currentUrl)

      let rep1 = `https://${currentUrl}/servidores/valvulas1_13.php?fecha=${this.date}`;
      let rep2 = `https://${currentUrl}/servidores/valvulas14_26.php?fecha=${this.date}`;
      let reporteCompleto = `https://${currentUrl}/servidores/reporteValvulasI.php?fecha=${this.date}`;
      let reporteCompletoDown = `https://${currentUrl}/servidores/reporteValvulasD.php?fecha=${this.date}`;

      fetch(rep1)
        .then( res => res.json())
        .then(data => {
          console.log(data)
          if (data.success){

            fetch(rep2)
              .then( res2 => res2.json()) 
              .then(data2 => {
                console.log(data2)
                if (data2.success){
                  if (accion === 'I') {
                    open(reporteCompleto, '_blank');
                    setTimeout(() => {
                      fetch(`https://${currentUrl}/servidores/borrarArchivos.php`)
                        .then(res => res.json())
                        .then(dataE => {
                          console.log(`Archivo 1 borrado: ${dataE.Borrado1}`);
                          console.log(`Archivo 2 borrado: ${dataE.Borrado2}`);
                        })
                    }, 3000);
                  } else {
                    
                    open(reporteCompletoDown);
        
                    setTimeout(() => {
                      fetch(`https://${currentUrl}/servidores/borrarArchivos.php`)
                        .then(res => res.json())
                        .then(dataE => {
                          console.log(`Archivo 1 borrado: ${dataE.Borrado1}`);
                          console.log(`Archivo 2 borrado: ${dataE.Borrado2}`);
                        })
                    }, 3000);
                    
                    
                    }
                } else {
                  data2.respuesta
                }
            })
            .catch( ee => {
              console.log(ee)
            })
          } else {
            data.respuesta;
          }
        })
        .catch( e => {
          console.log(e)
        })
        
    },
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'estacionSel'])
  },
  created () {
    this.iniciarComponente()
    this.date = moment().format('YYYY-MM-DD')
  },
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 50px;
  }

  .card-row {
    margin-bottom: 20px;
  }

  .button.is-dark:hover .button.is-dark.is-hovered {
    background-color: #3273dc;
  }
  @media (min-width: 320px) and (max-width: 480px) {

  }
</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/Reportes.vue